@if (noAccess) {
    <div class="no-access-message">
        <span>{{ "dataGraph.noAccessMessage" | t }}</span>
    </div>
} @else {
    <div class="data-chart">
        <div class="row">
            <div class="col-9 text-truncate">
                @if (data) {
                    <b [matTooltip]="data.name">{{ data.identifier }} - {{ data.name }}</b>
                }
            </div>
            <div class="col-3">
                <i
                    class="fas fa-question-circle float-end"
                    [matTooltip]="'dataGraph.viewInformation' | t"
                    (click)="showKriInfo()"
                ></i>
                <i
                    class="fas fa-redo float-end me-2"
                    [matTooltip]="'dataGraph.reload' | t"
                    (click)="load()"
                ></i>
                @if (showOpen) {
                    <i
                        class="fas fa-external-link float-end me-2"
                        [matTooltip]="'dataGraph.openKri' | t"
                        (click)="openKri()"
                    ></i>
                }
            </div>
        </div>
        <hr />
        <div class="chart-container" #chartContainer></div>
    </div>
}

<ng-template #kriInfoTemplate>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <label>{{ "dataGraph.aggregationMethod" | t }}</label>
                <input
                    class="form-control form-control-sm"
                    [value]="data.aggregationMethod"
                    readonly
                    disabled
                />
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label>{{ "dataGraph.aggregateScore" | t }}</label>
                <ng-select
                    [items]="[{ Name: data.aggregateScore, ID: 0 }]"
                    [disabled]="true"
                    [ngModel]="0"
                    bindLabel="Name"
                    bindValue="ID"
                >
                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                        <div
                            [style.background-color]="data.aggregateScoreColor"
                            style="
                                min-width: 5px;
                                min-height: 18px;
                                float: left;
                                margin-right: 5px;
                                position: relative;
                                top: 2px;
                            "
                        ></div>
                        {{ item.Name }}
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label>{{ "dataGraph.thresholdGreen" | t }}</label>
                <input
                    class="form-control form-control-sm"
                    [value]="data.greenThreshold"
                    readonly
                    disabled
                />
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label>{{ "dataGraph.thresholdRed" | t }}</label>
                <input
                    class="form-control form-control-sm"
                    [value]="data.redThreshold"
                    readonly
                    disabled
                />
            </div>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <label>{{ "dataGraph.totalDataEntries" | t }}</label>
                <input
                    class="form-control form-control-sm"
                    [value]="data.totalCount"
                    readonly
                    disabled
                />
            </div>
        </div>
        @for (count of data.counts; track count) {
            <div class="col-6">
                <div class="form-group">
                    <label>{{ count.key }}</label>
                    <input
                        class="form-control form-control-sm"
                        [value]="count.value"
                        readonly
                        disabled
                    />
                </div>
            </div>
        }
    </div>
</ng-template>
